import React from 'react';
import PropTypes from 'prop-types';
import CabinRate from './CabinRate';

const CabinGroup = ({
  cabinGroup, title, tripId, onModalClose, isConfirmation, selectedRoomIndex, doShowPrice,
  travelOption, tripRoomSearchInput,
}) => {
  const sortedCabins = cabinGroup.sort((a, b) => {
    const minA = Math.min(...a.rateOptions.map((ro) => ro.price));
    const minB = Math.min(...b.rateOptions.map((ro) => ro.price));
    return minA - minB;
  });

  return (
    <div>
      <div className="sm:mx-5 mx-0 mt-5 mb-5 sm:p-5 p-2 rounded-lg bg-theme bg-opacity-10 text-theme border border-theme border-opacity-10">
        {title}
      </div>
      {
        sortedCabins.map((cabin) => (
          <CabinRate
            key={cabin.cabinCategoryCode}
            onModalClose={onModalClose}
            tripId={tripId}
            cabin={cabin}
            isConfirmation={isConfirmation}
            selectedRoomIndex={selectedRoomIndex}
            doShowPrice={doShowPrice}
            travelOption={travelOption}
            tripRoomSearchInput={tripRoomSearchInput}
          />
        ))
      }
    </div>
  );
};

CabinGroup.defaultProps = {
  tripId: undefined,
  onModalClose: () => {},
};

CabinGroup.propTypes = {
  title: PropTypes.string.isRequired,
  cabinGroup: PropTypes.arrayOf(PropTypes.shape({})).isRequired,
  tripId: PropTypes.string,
  onModalClose: PropTypes.func,
  isConfirmation: PropTypes.bool.isRequired,
  doShowPrice: PropTypes.bool,
  selectedRoomIndex: PropTypes.number.isRequired,
  travelOption: PropTypes.shape({
    mode: PropTypes.number,
    key: PropTypes.string,
  }).isRequired,
  tripRoomSearchInput: PropTypes.arrayOf(PropTypes.shape()),
};

CabinGroup.defaultProps = {
  doShowPrice: true,
  tripRoomSearchInput: undefined,
};

export default CabinGroup;
